import { render } from "./SessionStocksDisplayOptions.vue?vue&type=template&id=4d966861&scoped=true"
import script from "./SessionStocksDisplayOptions.vue?vue&type=script&lang=js"
export * from "./SessionStocksDisplayOptions.vue?vue&type=script&lang=js"

import "./SessionStocksDisplayOptions.vue?vue&type=style&index=0&id=4d966861&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d966861"]])

export default __exports__